module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hres3cu-detail-complaint"
    }
  }, [_c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES3CUC4']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_codempid",
      "name": "desc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.codempid) + " - " + _vm._s(_vm.detail.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "numcom",
      "name": "numcom"
    }
  }, [_vm._v(_vm._s(_vm.indexSelected.numcom))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "numcom",
      "name": "numcom"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.indexSelected.dtecompl)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_typcompl",
      "name": "desc_typcompl"
    }
  }, [_vm._v(_vm._s(_vm.detail.typcompl) + " - " + _vm._s(_vm.detail.desc_typcompl))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "descompl",
      "name": "descompl"
    }
  }, [_vm._v(_vm._s(_vm.detail.descompl))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indexSelected.stacompl),
      expression: "indexSelected.stacompl"
    }],
    attrs: {
      "type": "radio",
      "id": "stacompl1",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.indexSelected.stacompl, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.indexSelected, "stacompl", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['80']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indexSelected.stacompl),
      expression: "indexSelected.stacompl"
    }],
    attrs: {
      "type": "radio",
      "id": "stacompl2",
      "value": "D",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.indexSelected.stacompl, "D")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.indexSelected, "stacompl", "D")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['90']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indexSelected.stacompl),
      expression: "indexSelected.stacompl"
    }],
    attrs: {
      "type": "radio",
      "id": "stacompl3",
      "value": "S",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.indexSelected.stacompl, "S")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.indexSelected, "stacompl", "S")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['100']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indexSelected.stacompl),
      expression: "indexSelected.stacompl"
    }],
    attrs: {
      "type": "radio",
      "id": "stacompl4",
      "value": "C",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.indexSelected.stacompl, "C")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.indexSelected, "stacompl", "C")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['110']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "desc_codappv",
      "name": "desc_codappv"
    }
  }, [_vm._v(_vm._s(_vm.detail.codappv) + " - " + _vm._s(_vm.detail.desc_codappv))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "filenam1",
      "name": "filenam1"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.detail.path_filenam1,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.filenam1))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "filenam2",
      "name": "filenam2"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.detail.path_filenam2,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.filenam2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "filenam3",
      "name": "filenam3"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.detail.path_filenam3,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.filenam3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC4']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.desnote))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-894063de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres3cu/detailComplaint.vue
// module id = 3923
// module chunks = 1